<template>
  <base-button
    class="relative w-full flex items-center gap-2 rounded-xs p-3 ring ring-grey-30 between forced-colors:b "
    :class="{ 'bg-grey-90': modelValue && unavailable }"
    @click="$emit('click')"
  >
    <span :class="{ 'c-grey-20': !modelValue }">
      <!-- @slot Slot for label -->
      <slot />
    </span>
    <span class="ml-a flex shrink-0 items-center gap-2">
      <span v-if="showPlaceholderStockHint && modelValue && unavailable" class="text-xs c-grey-20">
        {{ isNotifyMe ? $t.notifyMe : $t.outOfStock }}
      </span>
      <vf-icon dir="down" name="chevron" size="md" />
    </span>
  </base-button>
</template>

<script lang="ts" setup>
defineProps<{
  /**
   * Unavailable means the variant is out of stock, it will appear disabled but remain selectable
   */
  unavailable?: boolean
  showPlaceholderStockHint?: boolean
}>()

defineEmits<{
  click: []
}>()

const modelValue = defineModel<string>()
const { isNotifyMe } = usePdp() || {}
</script>
